/**
 * Asynchronously loads the component for ReleasePage
 */

import { lazyLoad } from 'utils/loadable';

export const Setting = lazyLoad(
  () => import('./index'),
  module => {
    return module.Setting;
  },
);
